// extracted by mini-css-extract-plugin
export default {"brand":"NavigationBrand_brand__KdKfs","brand__link":"NavigationBrand_brand__link__JPu5-"};